// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"rating_ratingContainer___YUr8","ratingTotalRating":"rating_ratingTotalRating__PoQim","ratingStar":"rating_ratingStar__9cN9e"};